












import {Component, Prop, Vue} from 'vue-property-decorator';

import CheckService from '@/app/account/shared/service/check.service';

@Component
export default class NContentHeader extends Vue {
  @Prop({type: String, default: ''})
  title!: string;

  @Prop({type: String, default: ''})
  documentTitle!: string;

  check = new CheckService();

  created() {
    if (!!this.documentTitle) {
      document.title = this.documentTitle;
    }
  }

  onHomePage() {
    window.open(`${process.env.VUE_APP_GENIE_MOBILE_WEB_DOMAIN}`, '_blank');
  }
}
